const breakpoint = 760;
const elementsToShow = document.querySelectorAll(".animate-on-scroll");
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

let scroll =
  window.requestAnimationFrame ||
  function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };

// forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}


/**
 *
 *
 *
 */
const init = function () {
  loop();
};

/**
 *
 *
 *
 */
const loop = function () {
  checkForElementEntrance( elementsToShow );
  scroll(loop);
};


/**
 *
 *
 *
 */
const checkForElementEntrance = function( elements ) {

  elements.forEach(element => {

    const baseClass = "animated";

    let desktopAnimation = element.getAttribute("data-desktop-animate");
    let mobileAnimation = element.getAttribute("data-mobile-animate");

    if (!mobileAnimation) {
      mobileAnimation = desktopAnimation;
    }

    if (!mobileAnimation && !desktopAnimation) {
      mobileAnimation = "fadeIn";
      desktopAnimation = "fadeIn";
    }

    // IE11 doesn't like SVGs. This detects them and bails.
    if (element.classList == null) {
      return;
    }

    // if we've already animated this, stop
    if (element.classList.contains(baseClass)) {
      return;
    }

    if (isElementInViewport(element)) {

      // activate counter
      if (element.classList.contains('js-counter') && !reducedMotion.matches) {
        initiateCounter(element);
      }

      if ( getWindowWidth() >= breakpoint ) {
        element.classList.add(baseClass);
        element.classList.add(desktopAnimation);
      } else {
        element.classList.add(baseClass);
        element.classList.add(mobileAnimation);
      }
    }

  });

}


/**
 *
 *
 *
 */
const getWindowWidth = function () {
  const win = window;
  const doc = document;
  const docElem = doc.documentElement;
  const body = doc.getElementsByTagName("body")[0];
  const x = win.innerWidth || docElem.clientWidth || body.clientWidth;

  return x;
};

/**
 *
 *
 *
 */
const isElementInViewport = el => {
  var rect = el.getBoundingClientRect();

  return (
    (rect.top <= 0 && rect.bottom >= 0) ||
    (rect.bottom >=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.top <=
      (window.innerHeight || document.documentElement.clientHeight)) ||
    (rect.top >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight))
  );

};


/**
 * jQuery
 *
 *
 */
const initiateCounter = function (element) {

  $(element).prop('Counter', 0).animate({
    Counter: $(element).data('counter')
  }, {
    duration: 2000,
    easing: 'swing',
    step: function (now) {
      if (Modernizr.flexbox) {
        // modern browsers
        $(element).text(Math.ceil(now).toLocaleString());
      } else {
        // support for older IE
        $(element).text(Math.ceil(now).toLocaleString('en').slice(0, -3));
      }
    }
  });

  // remove class to prevent firing after initial
  $(element).removeClass('js-counter');

};


const api = {
  init: init,
  checkForElementEntrance: checkForElementEntrance
};

export default api;
